import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';

const Loader: React.FC = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bg="gray.50"
    >
      <VStack spacing={4}>
        <Spinner size="xl" color="blue.500" thickness="4px" />
        <Text fontSize="lg" color="gray.600">
          Loading...
        </Text>
      </VStack>
    </Box>
  );
};

export default Loader; 